import { useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { useLoading } from 'shared/hooks'
import { REPORT_A_FLAW } from '../graphql'
import { IFeedback, IFeedbackArgument } from '../types'

export const useFeedback = () => {
  const [sendFeedbackMutation, { loading }] = useMutation<{ report: IFeedback }, { input: IFeedbackArgument }>(
    REPORT_A_FLAW
  )

  const sendFeedback = useCallback<(data: IFeedbackArgument) => Promise<IFeedback | undefined>>(
    async (input) => {
      const { data } = await sendFeedbackMutation({
        variables: { input }
      })
      return data?.report
    },
  [sendFeedbackMutation]
  )

  useLoading({
    isLoading: loading
  })

  return {
    sendFeedback
  }
}
